import { render, staticRenderFns } from "./ModalCouponPlanCardParts.vue?vue&type=template&id=1b4fb842&scoped=true"
import script from "./ModalCouponPlanCardParts.vue?vue&type=script&lang=ts"
export * from "./ModalCouponPlanCardParts.vue?vue&type=script&lang=ts"
import style0 from "./ModalCouponPlanCardParts.vue?vue&type=style&index=0&id=1b4fb842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4fb842",
  null
  
)

export default component.exports